import React from "react";

import leftImg from "../../assets/Left-Image.jpg";
import rightImg from "../../assets/Right-Image.jpg";
import logo from "../../assets/appIcon.png";
import { googlePLay } from "../../SVG";
import classes from "./TopSection.module.css";

const TopSection = (props) => {
  return (
    <div className={classes.TopSection}>
      <div
        className={classes.ImageContainers}
        style={{ backgroundImage: `url(${leftImg})` }}
      >
        <div className={classes.GooglePlay}>
          <a href="https://play.google.com/store/apps/details?id=com.ALO_Foodie_alo_foodie">
            {googlePLay}
            <div>Download Now</div>
            <img
              src={logo}
              alt="logo"
              style={{ width: "30px", height: "30px", margin: "auto 0.4rem" }}
            />
          </a>
        </div>
      </div>
      <div className={classes.Title}>
        <div>
          <span>A</span>
          <span>L</span>
          <span>O</span>
        </div>
        <div>
          <span>F</span>
          <span>O</span>
          <span>O</span>
          <span>D</span>
          <span>I</span>
          <span>E</span>
        </div>
      </div>
      <div
        className={classes.ImageContainers}
        style={{ backgroundImage: `url(${rightImg})` }}
      ></div>
    </div>
  );
};

export default TopSection;
